import { HttpClient } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MobilePhoneNumberService, NationalCodeService } from 'ngx-persian';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AccountService } from 'src/app/services/account.service';
import { OtherService } from 'src/app/services/other.service';
import { PersianNumberService } from 'ngx-persian';
import { MapService } from 'src/app/services/map.service';
import * as moment from 'moment-jalaali';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, Observable, of, Subject, switchMap, takeUntil, throwError } from 'rxjs';
import { GeolocationData, MapBuilderService } from 'src/app/services/map-builder.service';
import Swal from 'sweetalert2';

declare let $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-new-trip',
  templateUrl: './new-trip.component.html',
  styleUrls: ['./new-trip.component.css'],
})

export class NewTripComponent implements OnInit {
  list_City: any[] = [];
  bForAnother: Boolean = false;
  bHasStop: Boolean = false;
  bCargo: Boolean = false;
  bForeigner: Boolean = false;
  bInvoiceRequired: Boolean = false;
  showCustom_Map: boolean = false;
  isRequestingLocation: boolean = false;
  iState: number = 1;
  map: any;
  source: any;
  vector: any;
  layers: any = [];
  mapHeader: any;
  mapMode: any;
  vectorLayer: any;
  origin: any;
  destination: any;
  Info: any;
  currentTime: any = moment().format('jYYYY/jMM/jDD');
  currentClock: any;
  prices: any;
  invoice: any;
  atLeastTime: number;
  strHelp: string = '';

  constructor(
    private accountService: AccountService,
    private router: Router,
    private otherService: OtherService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private persianNumber: PersianNumberService,
    private _NationalCode: NationalCodeService,
    private _MapService: MapService,
    private snackBar: MatSnackBar,
    private mapBuilderService: MapBuilderService
  ) { }

  path: FormGroup = this.formBuilder.group({
    origin: new FormControl('', Validators.required),
    destination: new FormControl(''),
    olatIn: new FormControl(0, Validators.required),
    dlatIn: new FormControl('', Validators.required),
    olongIn: new FormControl(0, Validators.required),
    dlongIn: new FormControl('', Validators.required),
    addressBar: new FormControl(''),
    duration: new FormControl(''),
    distance: new FormControl(''),
  });

  mdl_Map: FormGroup = this.formBuilder.group({
    strAddress: new FormControl(''),

    fLon: new FormControl(''),

    fLat: new FormControl(''),

    strSource: new FormControl(''),
  });

  mdl_TripSAD: FormGroup = this.formBuilder.group({
    strSCity: new FormControl(''),
    strDCity: new FormControl(''),
    tiMobileGroup: new FormControl(1),
    tiPassenger: new FormControl(1),
    // strDate: new FormControl(''),
    strDate: this.persianNumber.toEnglish(new Date().toLocaleString('fa-ir')),
    strTime: new FormControl(''),
    strPassengersName: new FormControl(''),
    strName: new FormControl(''),
    strMobile: new FormControl(''),
    bForAnother: new FormControl(false),
    bHasStop: new FormControl(false),
    bCargo: new FormControl(false),
    bPet: new FormControl(false),
    bSmoking: new FormControl(false),
    bNeedHelp: new FormControl(false),
    bInvoiceRequired: new FormControl(false),
    bCameBack: new FormControl(false),
    bForeigner: new FormControl(false),
    strID: new FormControl('', Validators.required),
    fEstimateStop: new FormControl(''),
    strSAddress: new FormControl(''),
    strDAddress: new FormControl(''),
    strCargoDetail: new FormControl(''),
    strCompany: new FormControl(''),
    strPassportNumber: new FormControl(''),
    strComment: new FormControl(''),
    fSLon: new FormControl(0, Validators.required),
    fSLat: new FormControl(0, Validators.required),
    fDLon: new FormControl(0),
    fDLat: new FormControl(0),
  });

  mdl_Payment: FormGroup = this.formBuilder.group({

    iTaxiLon_User: this.otherService.getLocalStorage().Id,

    strSession: this.otherService.getLocalStorage().session,

    iTaxiLon_Trip: new FormControl(''),

    strSuccessURL: new FormControl(''),

    tiAppType: new FormControl('1'),

  })

  mdl_Voting: FormGroup = this.formBuilder.group({

    iTaxiLon_User: this.otherService.getLocalStorage().Id,

    strSession: this.otherService.getLocalStorage().session,

    iTaxiLon_Trip: new FormControl(''),

    iDriverPoints: new FormControl(''),

    tiDriverPoints: new FormControl(''),

    strPassengerOpinion: new FormControl(''),

    strSCityName: new FormControl(''),

    strDCityName: new FormControl(''),

    strDate: new FormControl(''),

  })

  private destroy$ = new Subject<void>();


  ngOnInit(): void {

    this.accountService.Taxilon_GetHelp().subscribe((data: any) => {
      this.strHelp = data;
    })

    this.Info = this.otherService.getLocalStorage();

    this.mdl_TripSAD.controls['strName'].setValue(this.Info.strName + ' ' + this.Info.strFamily);

    this.mdl_TripSAD.controls['strMobile'].setValue(this.Info.strMobile);

    this.mdl_TripSAD.controls['strID'].setValue(this.Info.strID.trim());

    this.getAtleastTime();

    this.getListCity();

    this.check_hasVoted();


  }

  ngAfterViewInit() {
    this.mdl_TripSAD.get('strSAddress')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.mdl_TripSAD.patchValue({
        fSLat: '',
        fSLon: ''
      });
    });

    this.mdl_TripSAD.get('strDAddress')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.mdl_TripSAD.patchValue({
        fDLat: '',
        fDLon: ''
      });
    })
  }

  ngOnDestroy() {

    $("#map_Modal").modal("hide");

    // Swal.fire({

    //   title: 'آیا از بستن صفحه اطمینان دارید ؟',

    //   icon: 'warning',

    //   showCancelButton: true,

    //   showConfirmButton: true,

    //   reverseButtons: true,

    //   confirmButtonColor: '#10b981',

    //   confirmButtonText: 'تایید',

    //   cancelButtonText: 'لغو',

    // }).then((result) => {

    //   if (result.isConfirmed) {

    //     this.router.navigateByUrl('/')

    //   }

    // })

  }

  check_hasVoted() {

    var model = {

      iTaxiLon_User: this.Info.Id,

      strSession: this.Info.session

    }

    this.accountService.taxiLon_CheckPoints(model).subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      if (res.length && res[0].strDate) {

        this.mdl_Voting.patchValue({

          iTaxiLon_Trip: res[0].iTaxiLon_Trip,

          strDate: res[0].strDate,

          strSCityName: res[0].strSCityName,

          strDCityName: res[0].strDCityName,

        })

        var myModal = new bootstrap.Modal(document.getElementById('Voting_Modal'), {});

        myModal.show();

      }

    });

  }

  changeState(e) {

    let model = this.mdl_TripSAD.value;
    model.iTaxiLon_User = this.Info.Id;
    model.strSession = this.Info.session;
    model.strID = model.strID == undefined ? '' : model.strID;

    this.otherService.markAllAsTouched(this.mdl_TripSAD)

    if (e == 2) {
      if (model.strID == '') return this.accountService.toastSwal('error', ' کد ملی را وارد کنید');
      if (!this._NationalCode.isValid(model.strID)) return this.accountService.toastSwal('error', 'کد ملی وارد شده صحیح نمی باشد');
      if (model.strTime == '') return this.accountService.toastSwal('error', 'ساعت را وارد کنید');
      if (model.strMobile == '') return this.accountService.toastSwal('error', 'موبایل را وارد کنید');
      if (model.strDate < this.currentTime) return this.accountService.toastSwal('error', 'تاریخ قبل از امروز را نمی توانید انتخاب کنید');
      if (model.strDate == this.currentTime) {

        function timeDifferenceInMinutes(time2) {
          const now = new Date();
          const hours = now.getHours();
          const minutes = now.getMinutes();
          const [hours2, minutes2] = time2.split(':').map(Number);
          const totalMinutes1 = hours * 60 + minutes;
          const totalMinutes2 = hours2 * 60 + minutes2;
          const differenceInMinutes = totalMinutes2 - totalMinutes1;
          return differenceInMinutes;
        }

        const differenceInSeconds = timeDifferenceInMinutes(model.strTime);
        if (differenceInSeconds < this.atLeastTime) {
          return this.accountService.toastSwal('error', `ساعت نمی تواند قبل از ${moment().add(this.atLeastTime / 60, 'hours').format("HH:mm")}.باشد`);
        }

      }

      if (model.strSCity == '')
        return this.accountService.toastSwal('error', 'شهر مبدا را وارد کنید');
      if (model.strDCity == '')
        return this.accountService.toastSwal('error', 'شهر مقصد را وارد کنید');
      if (model.strSAddress == '')
        return this.accountService.toastSwal('error', 'آدرس مبدا را وارد کنید');
      if (model.fSLon == '')
        return this.accountService.toastSwal(
          'error',
          'موقعیت مبدا را وارد کنید'
        );

      if (model.bForAnother == true && model.strPassengersName == '')
        return this.accountService.toastSwal('error', 'نام مسافر را وارد کنید');
      if (model.bHasStop == true && model.fEstimateStop == '')
        return this.accountService.toastSwal(
          'error',
          'مقدار توقف را وارد کنید'
        );
      if (model.bCargo == true && model.strCargoDetail == '')
        return this.accountService.toastSwal(
          'error',
          'توضیحات بار را وارد کنید'
        );
      if (model.bInvoiceRequired == true && model.strCompany == '')
        return this.accountService.toastSwal('error', 'نام شرکت را وارد کنید');
      if (model.bForeigner == true && model.strPassportNumber == '')
        return this.accountService.toastSwal(
          'error',
          'شماره پاسپورت را وارد کنید'
        );
      if (model.bForeigner == true && model.strPassportNumber == '')
        return this.accountService.toastSwal(
          'error',
          'شماره پاسپورت را وارد کنید'
        );

      model.tiMobileGroup = null;

      this.accountService.TaxiLon_User_TravelCostEstimate(model).subscribe((data: any) => {

        let res = JSON.parse(data.toString());

        this.prices = res;

      });

      this.iState = e;
    }

    else if (e == 3) {
      this.invoice = this.mdl_TripSAD.value;

      const matchingSCity = this.list_City.find(
        (city) => city.strCity == this.invoice.strSCity
      );
      const matchingDCity = this.list_City.find(
        (city) => city.strCity == this.invoice.strDCity
      );
      const matchingPrice = this.prices.find(
        (price) => price.tiMobileGroup == this.invoice.tiMobileGroup
      );

      this.invoice.strSCityComment = matchingSCity.strCityName;
      this.invoice.strDCityComment = matchingDCity.strCityName;
      this.invoice.iPrice = matchingPrice.iRent;
      this.invoice.iAdvancePayment = matchingPrice.iAdvancePayment;

      this.iState = e;
    }

    else {
      this.iState = e;
    }
  }

  getListCity = async () => {
    this.accountService.TaxiLon_City_List().subscribe((data: any) => {
      let res = JSON.parse(data.toString());
      this.list_City = res;
      this.mdl_TripSAD.patchValue({
        strSCity: this.Info.strCity,
        strSAddress: this.Info.strAddress,
        fSLat: this.Info.fLat,
        fSLon: this.Info.fLon
      }, { emitEvent: false });
    });
  }

  getAtleastTime() {
    this.accountService.TaxiLon_AtLeastTime().subscribe((data: any) => {
      let res = JSON.parse(data.toString());
      this.atLeastTime = res;
    });
  }

  tripSubmit() {
    let model = this.mdl_TripSAD.value;
    model.iTaxiLon_User = this.Info.Id;
    model.strSession = this.Info.session;
    model.iAdvancePayment = this.invoice.iAdvancePayment;
    model.iEstimateRent = this.invoice.iPrice;

    this.accountService.TaxiLon_Trip_Passenger_Save(model).subscribe((data: any) => {
      let res = JSON.parse(data.toString());

      if (res?.iResult <= 0) {
        this.accountService.toastSwal('error', res?.strError);
        return
      }

      if (res[0].iTaxiLon_Trip) {

        if (res[0].tiTripStatus == 0) {
          this.mdl_Payment.patchValue({
            iTaxiLon_Trip: res[0].iTaxiLon_Trip,
            strSuccessURL: `${window.location.origin}/taxilon/payment/callback/prepayment`
          })

          return this.payInvoice();
        }

        else {
          this.accountService.toastSwal('success', ` سفر شما با کد رهگیری ${res[0].iTaxiLon_Trip} ثبت شد`);

          if (this.strHelp) {
            Swal.fire({
              title: ` سفر شما با کد رهگیری ${res[0].iTaxiLon_Trip} ثبت شد`,
              text: this.strHelp,
              icon: 'success',
              showCancelButton: false,
              showConfirmButton: true,
              reverseButtons: true,
              confirmButtonColor: '#10b981',
              cancelButtonColor: '#EF4444',
              confirmButtonText: '!متوجه شدم',
            }).then((result) => {
              if (result.isConfirmed) {
                this.router.navigate(['/taxilon/allTrip']);
              }
            })
          } else {
            this.router.navigate(['/taxilon/allTrip']);
          }
        }

      }

      else {
        return this.accountService.toastSwal('error', 'خطا');
      }

    });

  }

  payInvoice() {
    this.iState = 4;
    this.accountService.taxiLon_PayInvoice(this.mdl_Payment.value).subscribe((data: any) => {
      let res = JSON.parse(data.toString());
      if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);
      window.open(res.strURL, '_self')
    });
  }

  setValue_Filter(event: any, strKey: string) {

    if (event?.strCityName) {

      if (strKey == 'strSCity') {

        this.mdl_TripSAD.patchValue({

          strSCity: event.strCity,

          fSLon: event.fLon,

          fSLat: event.fLat,

          strSAddress: ''

        }, { emitEvent: false });

      }

      else {
        this.mdl_TripSAD.patchValue({
          strDCity: event.strCity,
          fDLon: event.fLon,
          fDLat: event.fLat,
          strDAddress: ''
        }, { emitEvent: false });

      }

    }

    else {

      if (strKey == 'strSCity') {

        this.mdl_TripSAD.patchValue({

          strSCity: '',

          fSLon: '',

          fSLat: '',

          strSAddress: ''

        }, { emitEvent: false });

      }

      else {

        this.mdl_TripSAD.patchValue({

          strDCity: '',

          fDLon: '',

          fDLat: '',

          strDAddress: ''

        }, { emitEvent: false });

      }

    }

  }

  show_Map_2(mdl_Type: 'strSAddress' | 'strDAddress') {

    if (mdl_Type == 'strSAddress') {

      if (this.mdl_TripSAD.get('strSCity')?.value.trim() == '') return this.accountService.toastSwal('error', 'شهر مبداء را انتخاب کنید');

      if (this.mdl_TripSAD.get('strSAddress')?.value.trim() == '') {

        this._MapService.getCurrentLocation().then(coords => {

          this.mdl_Map.patchValue({

            strAddress: this.mdl_TripSAD.get('strSAddress')?.value,

            fLon: coords.longitude,

            fLat: coords.latitude,

            strSource: 'strSAddress',

          });

          this.showCustom_Map = true;

        }).catch(error => {

          this.mdl_Map.patchValue({

            strAddress: this.mdl_TripSAD.get('strSAddress')?.value,

            fLon: this.mdl_TripSAD.get('fSLon')?.value,

            fLat: this.mdl_TripSAD.get('fSLat')?.value,

            strSource: 'strSAddress',

          });

          this.showCustom_Map = true;

          console.error('Error getting location:', error);

        });


      }

      else {

        this.mdl_Map.patchValue({

          strAddress: this.mdl_TripSAD.get('strSAddress')?.value,

          fLon: this.mdl_TripSAD.get('fSLon')?.value,

          fLat: this.mdl_TripSAD.get('fSLat')?.value,

          strSource: 'strSAddress',

        });

        this.showCustom_Map = true;


      }

    }

    else {

      if (this.mdl_TripSAD.get('strDCity')?.value.trim() == '') return this.accountService.toastSwal('error', 'شهر مقصد را انتخاب کنید');

      this.mdl_Map.patchValue({
        strAddress: this.mdl_TripSAD.get('strDAddress')?.value,

        fLon: this.mdl_TripSAD.get('fDLon')?.value,

        fLat: this.mdl_TripSAD.get('fDLat')?.value,

        strSource: 'strDAddress',
      });

      this.showCustom_Map = true;
    }

  }

  show_Map(mdl_Type: 'strSAddress' | 'strDAddress') {

    if (mdl_Type == 'strSAddress') {

      if (this.mdl_TripSAD.get('strSCity')?.value.trim() == '') return this.accountService.toastSwal('error', 'شهر مبداء را انتخاب کنید');

      if (this.mdl_TripSAD.get('strSAddress')?.value.trim() == '') {

        this._MapService.getCurrentLocation().then(coords => {

          this.mdl_Map.patchValue({

            strAddress: this.mdl_TripSAD.get('strSAddress')?.value,

            fLon: coords.longitude,

            fLat: coords.latitude,

            strSource: 'strSAddress',

          });

          this.showCustom_Map = true;

        }).catch(error => {

          this.mdl_Map.patchValue({

            strAddress: this.mdl_TripSAD.get('strSAddress')?.value,

            fLon: this.mdl_TripSAD.get('fSLon')?.value,

            fLat: this.mdl_TripSAD.get('fSLat')?.value,

            strSource: 'strSAddress',

          });

          this.showCustom_Map = true;

          console.error('Error getting location:', error);

        });


      }

      else {

        let cityName = this.returnStrValue('strCity', this.mdl_TripSAD.get('strSCity')?.value, this.list_City, 'strCityName');

        let address = !this.mdl_TripSAD.get('strSAddress')?.value.startsWith(cityName) ? cityName + '، ' + this.mdl_TripSAD.get('strSAddress')?.value : this.mdl_TripSAD.get('strSAddress')?.value;

        this.mdl_Map.patchValue({

          strAddress: address,

          fLon: this.mdl_TripSAD.get('fSLon')?.value,

          fLat: this.mdl_TripSAD.get('fSLat')?.value,

          strSource: 'strSAddress',

        });

        this.showCustom_Map = true;


      }

    }

    else {

      if (this.mdl_TripSAD.get('strDCity')?.value == '') return this.accountService.toastSwal('error', 'ابتدا شهر مقصد خود را وارد کنید')

      let cityName = this.returnStrValue('strCity', this.mdl_TripSAD.get('strDCity')?.value, this.list_City, 'strCityName');

      let address = !this.mdl_TripSAD.get('strDAddress')?.value.startsWith(cityName) ? cityName + '، ' + this.mdl_TripSAD.get('strDAddress')?.value : this.mdl_TripSAD.get('strDAddress')?.value;

      this.mdl_Map.patchValue({

        strAddress: address,

        fLon: this.mdl_TripSAD.get('fDLon')?.value,

        fLat: this.mdl_TripSAD.get('fDLat')?.value,

        strSource: 'strDAddress'

      })

      this.showCustom_Map = true;

    }

  }

  submitMap(event: any) {
    this.showCustom_Map = false;

    if (this.mdl_Map.get('strSource')?.value == 'strSAddress') {
      if (event.strText != '') {
        this.mdl_TripSAD.patchValue({
          strSAddress: event.strText,

          fSLon: event.longitude,

          fSLat: event.latitude,
        }, { emitEvent: false });
      } else {
        this.mdl_TripSAD.patchValue({
          strSAddress: '',

          fSLon: '',

          fSLat: '',
        }, { emitEvent: false });
      }
    } else {
      if (event.strText != '') {
        this.mdl_TripSAD.patchValue({
          strDAddress: event.strText,

          fDLon: event.longitude,

          fDLat: event.latitude,
        }, { emitEvent: false });
      } else {
        this.mdl_TripSAD.patchValue({
          strDAddress: '',

          fDLon: '',

          fDLat: '',
        }, { emitEvent: false });
      }
    }
  }

  returnStrValue(
    strKey: string,
    strKeyValue: number | string,
    lst_: [] | any,
    strComment: string
  ): string {
    return this.otherService.initialFilterValue(
      strKey,
      strKeyValue,
      lst_,
      strComment
    );
  }

  visiblityForAnother() {
    if (this.mdl_TripSAD.value.bForAnother == false) {
      this.bForAnother = false;
    } else {
      this.bForAnother = true;
    }
  }

  visiblityHasStop() {
    if (this.mdl_TripSAD.value.bHasStop == false) {
      this.bHasStop = false;
    } else {
      this.bHasStop = true;
    }
  }

  visiblityCargo() {
    if (this.mdl_TripSAD.value.bCargo == false) {
      this.bCargo = false;
    } else {
      this.bCargo = true;
    }
  }

  visiblityInvoiceRequired() {
    if (this.mdl_TripSAD.value.bInvoiceRequired == false) {
      this.bInvoiceRequired = false;
    } else {
      this.bInvoiceRequired = true;
    }
  }

  visiblityForeigner() {
    if (this.mdl_TripSAD.value.bForeigner == false) {
      this.bForeigner = false;
    } else {
      this.bForeigner = true;
    }
  }

  showAgree() {
    if (this.mdl_TripSAD.value.bAgreement == true) {
      this.bForAnother = false;
    } else {
      this.bForAnother = true;
    }
  }

  submitVote() {

    if (!this.mdl_Voting.get('iDriverPoints')?.value.rating || this.mdl_Voting.get('iDriverPoints')?.value.rating == '') {

      return this.accountService.toastSwal('error', 'میزان رضایت خود را مشخص کنید');

    }

    else {

      this.mdl_Voting.get('tiDriverPoints').setValue(this.mdl_Voting.get('iDriverPoints')?.value.rating);

      this.accountService.taxiLon_SetPoints(this.otherService.stringNumberToNumber(this.mdl_Voting.value)).subscribe((data: any) => {

        let res = JSON.parse(data.toString());

        if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);

        bootstrap.Modal.getInstance(document.getElementById('Voting_Modal')).hide();

        this.accountService.toastSwal('success', 'نظر شما با موفقیت ثبت شد');

      });

    }

  }

  // handle map and address

  public openMap(type: 'strSAddress' | 'strDAddress'): void {
    const model = this.mdl_TripSAD.value;

    if (type == 'strSAddress') {
      const cityId = model.strSCity;
      const address = model.strSAddress;
      const cityName = this.getCityNameById(cityId, this.list_City);

      if (cityId.trim() === '') {
        this.accountService.toastSwal('error', 'شهر مبداء را انتخاب کنید');
        return;
      }

      if (address.trim() === '') {
        this.requestAndSetCurrentLocation(type).subscribe({
          error: (err) => {
            const defaultCoords = { lat: model.fSLat, lon: model.fSLon };
            if (defaultCoords.lat && defaultCoords.lon) {
              this.setMapWithFixedLocation('', defaultCoords.lon, defaultCoords.lat, type);
            }
          }
        })
      }

      else {
        const finalAddress = this.buildFullAddress(cityName, address);
        this.setMapWithFixedLocation(finalAddress, model.fSLon, model.fSLat, type);
      }

    }

    else {
      const cityId = model.strDCity;
      const address = model.strDAddress;
      const cityName = this.getCityNameById(cityId, this.list_City);

      if (cityId.trim() === '') {
        this.accountService.toastSwal('error', 'شهر مقصد را انتخاب کنید');
        return;
      }

      if (address.trim() === '' && model.fDLon === 0) {
        this.requestAndSetCurrentLocation(type).subscribe({
          error: (err) => {
            const defaultCoords = { lat: model.fDLat, lon: model.fDLon };
            if (defaultCoords.lat && defaultCoords.lon) {
              this.setMapWithFixedLocation('', defaultCoords.lon, defaultCoords.lat, type);
            }
          }
        });
      }

      else {
        const finalAddress = this.buildFullAddress(cityName, address);
        this.setMapWithFixedLocation(finalAddress, model.fDLon, model.fDLat, type);
      }

    }

  }

  private getCityNameById(cityId: string, cityList: any[], cityNameKey: string = 'strCityName'): string {
    if (!cityId || !cityList) {
      return '';
    }

    const city = cityList.find(c => c.strCity === cityId);
    return city ? city[cityNameKey] : '';
  }

  private buildFullAddress(cityName: string, address: string): string {
    if (!address) {
      return '';
    }

    return !address.startsWith(cityName) ? `${cityName}، ${address}` : address;
  }

  private requestAndSetCurrentLocation(source: 'strSAddress' | 'strDAddress'): Observable<GeolocationData> {
    this.isRequestingLocation = true;
    return this.mapBuilderService.requestCurrentLocation$().pipe(
      switchMap((location: GeolocationData) => {
        const coordinates: [number, number][] = [[location.longitude, location.latitude]];
        this.mapBuilderService.fitMapToCoordinates(coordinates);
        this.mdl_Map.patchValue({
          strAddress: '',
          fLon: location.longitude,
          fLat: location.latitude,
          strSource: source,
        });
        this.showCustom_Map = true;
        this.isRequestingLocation = false;
        return of(location);
      }),
      catchError((err) => {
        this.toastr.error('', err);
        this.isRequestingLocation = false;
        this.showCustom_Map = true;
        return throwError(() => new Error(err));
      })
    );
  }

  private setMapWithFixedLocation(address: string, longitude: number, latitude: number, source: 'strSAddress' | 'strDAddress'): void {
    this.mdl_Map.patchValue({
      strAddress: address,
      fLon: longitude,
      fLat: latitude,
      strSource: source,
    });

    this.showCustom_Map = true;
  }

  hasOptions(): number {
    const model = this.invoice;
    return [
      model?.bCameBack,
      model?.bHasStop,
      model?.bCargo,
      model?.bPet,
      model?.bNeedHelp,
      model?.bSmoking,
    ].filter(Boolean).length;
  }

    filterNumericInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9۰-۹]/g, '')
  }


}
